/**
 * Request an environment-bound verification email from the authenticated
 * backend. The one-time action code never passes through client JavaScript.
 */

import { ServerURI } from "../globals";
import { getAuthHeaders } from "./apiUtils";
import { sanitizeAuthActionError } from "./emailVerification";

export async function requestEmailVerification(user) {
  try {
    // Signup/login already have an authenticated credential user. Another tab
    // can clear auth.currentUser before delivery; keep this request bound to
    // the identity that completed authentication instead of rereading it.
    const token = user ? await user.getIdToken() : null;
    const headers = user
      ? { "Content-Type": "application/json", ...(token && { Authorization: `Bearer ${token}` }) }
      : await getAuthHeaders();
    if (!headers.Authorization) {
      return { success: false, error: "Please sign in again to request a verification email." };
    }
    const response = await fetch(`${ServerURI}/api/auth/email-verification`, {
      method: "POST",
      headers,
    });
    const body = await response.json();

    if (response.ok && body.emailSent) {
      return { success: true, emailDeliveryStatus: body.emailDeliveryStatus };
    }

    return {
      success: false,
      error: body.error || `Error ${response.status}`,
      emailDeliveryStatus: body.emailDeliveryStatus,
    };
  } catch (error) {
    console.error("[verificationService] requestEmailVerification error:", sanitizeAuthActionError(error));
    return { success: false, error: sanitizeAuthActionError(error, error?.message || "Verification request failed") };
  }
}
